export default "__VITE_ASSET__qk69s9L___"